export const FarmMenuItems: Array<IMenu> = [
  {
    role: 'home',
    title: 'خانه',
    icon: 'icon-home_deselect',
    route: '/farm/home',
    main: false,
  },
  {
    role: 'buyers',
    title: 'خریداران',
    icon: 'icon-buyer',
    route: '/farm/buyers',
    main: false,
  },
  {
    role: 'add-ad',
    title: 'ثبت آگهی',
    icon: 'icon-ad',
    route: '/farm/add-ad',
    main: true,
  },
  {
    role: 'chats',
    title: 'پیام ها',
    icon: 'icon-chat',
    route: '/farm/chats',
    main: false,
  },
  {
    role: 'account',
    title: 'حساب من',
    icon: 'icon-account',
    route: '/farm/account',
    main: false,
  },
];
